import React, { ReactElement } from 'react';
import { DiagnosisCategory } from '../../types/diagnosis/diagnosis-category.type';
import DiagnosisListCard from '../../constants/diagnosis/diagnosis-list.card';
import DiagnosisCategoryLoader from '../../constants/diagnosis/loader/diagnosis-category.loader';

export default function DiagnosisCategoryContain(props: {
	diagnosisCategory: DiagnosisCategory | null;
	fetchFn?: Function;
}): ReactElement {
	return (
		<div className="my-12">
			{props.diagnosisCategory ? (
				<div className="text-center mb-6">
					<h2 className="text-2xl font-bold">{props.diagnosisCategory.title}</h2>
					<p className="text-gray-500">{props.diagnosisCategory.sub_title}</p>
				</div>
			) : (
				<div className="flex justify-center">
					<DiagnosisCategoryLoader />
				</div>
			)}
			<div className="grid gap-6">
				{props.diagnosisCategory
					? props.diagnosisCategory.diagnosis_array.map((e, k) => (
							<DiagnosisListCard key={k} diagnosis={e} />
					  ))
					: Array(3)
							.fill(null)
							.map((_, k) => (
								<DiagnosisListCard key={k} diagnosis={null} fetchFn={props.fetchFn} />
							))}
			</div>
		</div>
	);
}
